export enum CriteriaSubject {
  TIME_ESTIMATE = 'time estimate',
  CUSTOM_ESTIMATE = 'custom estimate'
}

export const CriteriaSubjectReverseMap = {
  'time estimate': CriteriaSubject.TIME_ESTIMATE,
  'custom estimate': CriteriaSubject.CUSTOM_ESTIMATE
}

export enum CriteriaComparison {
  LESS_THAN = '<',
  LESS_THAN_OR_EQUAL = '<=',
  EQUAL = '=',
  MORE_THAN_OR_EQUAL = '>=',
  MORE_THAN = '>'
}

export const CriteriaComparisonReverseMap = {
  '<': CriteriaComparison.LESS_THAN,
  '<=': CriteriaComparison.LESS_THAN_OR_EQUAL,
  '=': CriteriaComparison.EQUAL,
  '>=': CriteriaComparison.MORE_THAN_OR_EQUAL,
  '>': CriteriaComparison.MORE_THAN
}

// "...when time estimate is <= 80 hours..."
export class SuccessCriteria {
  subject: CriteriaSubject;
  condition: CriteriaComparison;
  amount: number;
  description: string;
  customEstimateTitle: string;

  constructor(
    subject: CriteriaSubject,
    condition: CriteriaComparison,
    amount: number,
    description?: string,
    customEstimateTitle?: string
    ) {
    this.subject = subject;
    this.condition = condition;
    this.amount = amount;
    this.description = description || this.formatAsString();
    this.customEstimateTitle = customEstimateTitle || CriteriaSubject.CUSTOM_ESTIMATE;
  }

  formatAsString(): string {
    let str = this.subject + ' is ' + this.condition + ' ' + this.amount;
    if (this.subject === CriteriaSubject.TIME_ESTIMATE) {
      str += ' (hours)';
    }

    return str; 
  }
}


// WEBPACK FOOTER //
// ./src/models/project/SuccessCriteria.ts